document.addEventListener('DOMContentLoaded', function () {
  (async () => {
    const SHOP_DOMAIN = 'myline24.myshopify.com';      // Your shop domain
    const STOREFRONT_TOKEN = 'b4a2a3cde00bde9fb84e2e2bf47d7f1a'; // Storefront API token

    // Get the section(s) that need recipes slider init
    const sections = document.querySelectorAll('.recipe-ideas-section[data-section-id]');
    if (!sections.length) return;

    // Helper to parse article handles from metafield value
    function parseArticleHandles(rawValue) {
      if (!rawValue) return [];

      let paths = [];

      try {
        const parsedJSON = JSON.parse(rawValue);
        if (Array.isArray(parsedJSON)) {
          paths = parsedJSON;
        } else {
          paths = rawValue.split(/\r?\n|,/).map(s => s.trim()).filter(Boolean);
        }
      } catch {
        paths = rawValue.split(/\r?\n|,/).map(s => s.trim()).filter(Boolean);
      }

      return paths
        .map(path => {
          const match = path.match(/^\/blogs\/([^\/]+)\/([^\/]+)$/);
          if (!match) return null;
          return { blogHandle: match[1], articleHandle: match[2] };
        })
        .filter(Boolean);
    }

    // Fetch the product handle from URL
    function getProductHandle() {
      const path = window.location.pathname;
      let match = path.match(/^\/collections\/[^\/]+\/products\/([^\/]+)/);
      if (match) return match[1];
      match = path.match(/^\/products\/([^\/]+)/);
      if (match) return match[1];
      return null;
    }

    // GraphQL fetch function
    async function fetchGraphQL(query, variables = {}) {
      const res = await fetch(`https://${SHOP_DOMAIN}/api/2025-04/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
        },
        body: JSON.stringify({ query, variables }),
      });
      const json = await res.json();
      if (json.errors) {
        console.error('GraphQL errors:', json.errors);
        return null;
      }
      return json.data;
    }

    // Fetch product metafield "connected_recipes"
    async function fetchProductMetafield(productHandle) {
      const query = `
        query getProductMetafield($handle: String!) {
          product(handle: $handle) {
            metafield(namespace: "custom", key: "connected_recipes") {
              value
            }
          }
        }
      `;
      const data = await fetchGraphQL(query, { handle: productHandle });
      return data?.product?.metafield?.value || null;
    }

    // Fetch articles by blog handle (up to 250)
    async function fetchArticlesByBlog(blogHandle) {
      const query = `
        query getArticlesByBlog($blogHandle: String!) {
          blogByHandle(handle: $blogHandle) {
            articles(first: 250) {
              edges {
                node {
                  title
                  handle
                  onlineStoreUrl
                  image {
                    url
                    altText
                  }
                }
              }
            }
          }
        }
      `;
      const data = await fetchGraphQL(query, { blogHandle });
      return data?.blogByHandle?.articles?.edges.map(edge => edge.node) || [];
    }

    // Function to check if slider needs to wrapAround
    function checkChildWidth(parentElement, childElements) {
      try {
        const parentWidth = parentElement.offsetWidth;
        let totalChildWidth = 0;
        childElements.forEach((child, index) => {
          const childWidth = child.offsetWidth;
          const style = window.getComputedStyle(child);
          const marginRight = parseInt(style.marginRight, 10) || 0;
          totalChildWidth += childWidth + (index < childElements.length - 1 ? marginRight : 0);
        });
        return totalChildWidth > parentWidth;
      } catch (error) {
        console.error("An error occurred:", error);
        return false;
      }
    }

    const productHandle = getProductHandle();
    if (!productHandle) {
      console.error('Not on a product page or product handle not found');
      return;
    }

    const rawMetafieldValue = await fetchProductMetafield(productHandle);
    if (!rawMetafieldValue) {
      console.error('Metafield "connected_recipes" is empty or missing.');
      // Hide all recipe-ideas sections since no metafield value
      sections.forEach(sectionWrapper => {
        sectionWrapper.style.display = 'none';
      });
      return;
    }

    const articlesToFetch = parseArticleHandles(rawMetafieldValue);
    if (articlesToFetch.length === 0) {
      console.error('No valid article handles found in metafield.');
      // Hide all recipe-ideas sections since no articles
      sections.forEach(sectionWrapper => {
        sectionWrapper.style.display = 'none';
      });
      return;
    }

    // Group article handles by blog
    const blogGroups = articlesToFetch.reduce((acc, { blogHandle, articleHandle }) => {
      if (!acc[blogHandle]) acc[blogHandle] = [];
      acc[blogHandle].push(articleHandle);
      return acc;
    }, {});

    for (const sectionWrapper of sections) {
      const sectionId = sectionWrapper.getAttribute('data-section-id');
      if (!sectionId) continue;

      const container = document.getElementById(`recipe-slider-${sectionId}`);
      if (!container) {
        console.error(`Container with ID recipe-slider-${sectionId} not found`);
        continue;
      }

      let html = '';

      // For each blog, fetch articles and filter by handles
      for (const [blogHandle, handles] of Object.entries(blogGroups)) {
        const blogArticles = await fetchArticlesByBlog(blogHandle);
        if (!blogArticles.length) continue;

        const matchedArticles = blogArticles.filter(a => handles.includes(a.handle));
        matchedArticles.forEach(article => {
          const title = article.title;
          const url = article.onlineStoreUrl;
          const altText = title;
          const imgSrc = article.image?.url || '';

          const srcset = `
            ${imgSrc}?width=165 165w,
            ${imgSrc}?width=350 350w,
            ${imgSrc}?width=750 750w,
            ${imgSrc}?width=1200 1200w,
            ${imgSrc} 1280w
          `.trim().replace(/\s+/g, ' ');

          html += `
            <div class="recipe-media-item">
              <a href="${url}" class="recipe-media-item-link" aria-label="${altText}">
                <div class="image-parent">
                  <img
                    class="image"
                    srcset="${srcset}"
                    src="${imgSrc}?width=1500"
                    sizes="(min-width: px)"
                    alt="${altText}"
                    loading="lazy"
                    width="1280"
                    height="410"
                  >
                  <div class="rounded-button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="0.8125rem" height="0.75rem" viewBox="0 0 13 12" fill="none">
                      <path d="M0.5 6H11.5M11.5 6L6.16667 1M11.5 6L6.16667 11" stroke="var(--primary-fill-color)" stroke-width="0.8" stroke-linecap="round"></path>
                    </svg>
                  </div>
                </div>
                <p class="recipe-title paragraph-xs">${title}</p>
              </a>
            </div>
          `;
        });
      }

      container.innerHTML = html;

      // If no articles (empty html), hide the entire section and skip slider init
      if (!html.trim()) {
        sectionWrapper.style.display = 'none';
        continue;
      } else {
        // Show section if it was previously hidden
        sectionWrapper.style.display = '';
      }

      // Flickity init after HTML injection
      const existingSlider = Flickity.data(container);
      if (existingSlider) {
        existingSlider.destroy();
      }

      const recipesListItems = container.querySelectorAll('.recipe-media-item');
      const tabsLoop = checkChildWidth(container, recipesListItems);

      if (tabsLoop) {
        new Flickity(container, {
          cellAlign: 'left',
          contain: true,
          pageDots: false,
          prevNextButtons: false,
          adaptiveHeight: true,
          groupCells: 1,
          wrapAround: tabsLoop
        });
      }
    }
  })();
});
